import React from 'react';
import { useI18n } from '../i18n';

export function LanguageSwitcher({ className = '' }) {
  const { lang, setLang } = useI18n();

  const handleClick = (e, newLang) => {
    e.stopPropagation();
    e.preventDefault();
    setLang(newLang);
  };

  return (
    <div className={`flex items-center gap-1 ${className}`} data-testid="language-switcher">
      <button
        onClick={(e) => handleClick(e, 'sv')}
        className={`px-2 py-1 rounded text-xs font-medium transition-colors ${
          lang === 'sv' 
            ? 'bg-white/10 text-zinc-100' 
            : 'text-zinc-500 hover:text-zinc-300'
        }`}
        data-testid="lang-sv"
        type="button"
      >
        SV
      </button>
      <button
        onClick={(e) => handleClick(e, 'en')}
        className={`px-2 py-1 rounded text-xs font-medium transition-colors ${
          lang === 'en' 
            ? 'bg-white/10 text-zinc-100' 
            : 'text-zinc-500 hover:text-zinc-300'
        }`}
        data-testid="lang-en"
        type="button"
      >
        EN
      </button>
    </div>
  );
}
